(function () {
  'use strict';

  var SECTION_SEL = '.blog-template-1';
  var PILL_SEL    = '.blog-template-1__filter-pill';
  var ARTICLE_SEL = '.blog-template-1__article-row';
  var FEAT_SEL    = '.blog-template-1__featured-wrap';
  var PAGIN_SEL   = '.blog-template-1__pagination';
  var RECENT_HEAD = '.blog-template-1__recent-heading';
  var INIT_FLAG   = 'data-blog-js-init';

  /* Module-level state */
  var currentClientPage = 1;
  var currentFilter     = '';

  function getParam(url, key) {
    try { return new URL(url, location.origin).searchParams.get(key) || ''; }
    catch (e) { return ''; }
  }

  function buildUrl(base, overrides) {
    try {
      var u = new URL(base, location.origin);
      Object.keys(overrides).forEach(function (k) {
        if (overrides[k]) { u.searchParams.set(k, overrides[k]); }
        else { u.searchParams.delete(k); }
      });
      return u.toString();
    } catch (e) { return base; }
  }

  /* ── Pagination ── */

  function changeClientPage(section, pageNum) {
    currentClientPage = pageNum;
    applyFilterUI(section, currentFilter, true);
    var list = section.querySelector('.blog-template-1__list');
    if (list) {
      var offset = list.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  }

  function renderClientPagination(section, total, perPage) {
    var nav = section.querySelector(PAGIN_SEL);
    if (!nav) return;
    nav.innerHTML = '';

    var totalPages = Math.ceil(total / perPage);
    if (totalPages < 1) totalPages = 1;

    if (currentClientPage > 1) {
      var prev = document.createElement('a');
      prev.href = '#';
      prev.className = 'blog-template-1__page-btn blog-template-1__page-btn--arrow';
      prev.innerHTML = '&#8249;';
      prev.setAttribute('aria-label', 'Previous');
      prev.onclick = function (e) { e.preventDefault(); changeClientPage(section, currentClientPage - 1); };
      nav.appendChild(prev);
    }

    for (var i = 1; i <= totalPages; i++) {
      if (i === currentClientPage) {
        var active = document.createElement('span');
        active.className = 'blog-template-1__page-btn blog-template-1__page-btn--active';
        active.textContent = i;
        nav.appendChild(active);
      } else {
        var btn = document.createElement('a');
        btn.href = '#';
        btn.className = 'blog-template-1__page-btn';
        btn.textContent = i;
        btn.onclick = (function (p) {
          return function (e) { e.preventDefault(); changeClientPage(section, p); };
        })(i);
        nav.appendChild(btn);
      }
    }

    if (currentClientPage < totalPages) {
      var next = document.createElement('a');
      next.href = '#';
      next.className = 'blog-template-1__page-btn blog-template-1__page-btn--arrow';
      next.innerHTML = '&#8250;';
      next.setAttribute('aria-label', 'Next');
      next.onclick = function (e) { e.preventDefault(); changeClientPage(section, currentClientPage + 1); };
      nav.appendChild(next);
    }
  }

  /* ── Filtering ── */

  function applyFilterUI(section, activeFilter, isPageChange) {
    var af = (activeFilter || '').toLowerCase().trim();
    currentFilter = af;
    if (!isPageChange) currentClientPage = 1;

    var pData  = document.getElementById('blog-pagination-data');
    var perPage = pData ? parseInt(pData.getAttribute('data-per-page') || '8', 10) : 8;

    /* Update active pill */
    section.querySelectorAll(PILL_SEL).forEach(function (pill) {
      pill.classList.toggle(
        'blog-template-1__filter-pill--active',
        getParam(pill.href, 'filter').toLowerCase() === af
      );
    });

    /* Collect matching articles */
    var matching = [];
    section.querySelectorAll(ARTICLE_SEL).forEach(function (article) {
      var cats        = (article.getAttribute('data-categories') || '').toLowerCase().split(',').filter(Boolean);
      var parent      = article.parentElement;
      var isDuplicate = parent && parent.getAttribute('data-is-duplicate') === 'true';

      var match;
      if (af === '') {
        match = !isDuplicate;           /* ALL: exclude featured duplicate */
      } else if (af === 'new') {
        match = true;                   /* NEW: all articles including the first */
      } else {
        match = cats.indexOf(af) !== -1; /* Category filter */
      }

      /* Hide everything first — both the <a> and its wrapper <div> */
      article.style.display = 'none';
      if (parent) parent.style.display = 'none';

      if (match) matching.push({ el: article, parent: parent });
    });

    /* Show current page slice — unhide both the <a> and its wrapper */
    var start = (currentClientPage - 1) * perPage;
    var end   = start + perPage;
    matching.forEach(function (item, idx) {
      if (idx >= start && idx < end) {
        item.el.style.display = '';
        if (item.parent) item.parent.style.display = '';
      }
    });

    /* Featured hero: visible only on ALL, page 1 */
    var feat = section.querySelector(FEAT_SEL);
    if (feat) feat.style.display = (af === '' && currentClientPage === 1) ? '' : 'none';

    renderClientPagination(section, matching.length, perPage);

    var heading = section.querySelector(RECENT_HEAD);
    if (heading) heading.style.display = matching.length > 0 ? '' : 'none';

    /* Newsletter CTA: move it after the Nth article on the current page */
    var newsletterEl = document.getElementById('blog-newsletter-cta');
    if (newsletterEl) {
      var afterN      = pData ? parseInt(pData.getAttribute('data-newsletter-after') || '4', 10) : 4;
      var pageSlice   = matching.slice(start, end);
      if (pageSlice.length > 0) {
        var insertIdx   = Math.min(afterN - 1, pageSlice.length - 1);
        var anchorWrap  = pageSlice[insertIdx].parent;
        anchorWrap.parentNode.insertBefore(newsletterEl, anchorWrap.nextSibling);
        newsletterEl.style.display = '';
      } else {
        newsletterEl.style.display = 'none';
      }
    }
  }

  /* ── Background-fetch pages 2, 3, … so all articles are available ── */

  function fetchAdditionalPages(section) {
    var pData = document.getElementById('blog-pagination-data');
    if (!pData) return;

    var totalServerPages = parseInt(pData.getAttribute('data-total-pages') || '1', 10);
    if (totalServerPages <= 1) return; /* All articles already in DOM */

    var list = section.querySelector('.blog-template-1__list');
    if (!list) return;

    /* Build page URLs preserving view/preview params, removing filter, adding page */
    var pageNums = [];
    for (var p = 2; p <= totalServerPages; p++) pageNums.push(p);

    /* Fetch all pages in parallel, collect wrappers in order, then append */
    Promise.all(pageNums.map(function (pageNum) {
      var url = buildUrl(location.href, { page: String(pageNum), filter: '' });
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc      = new DOMParser().parseFromString(html, 'text/html');
          var pageList = doc.querySelector('.blog-template-1__list');
          var wrappers = [];
          if (pageList) {
            pageList.querySelectorAll('[data-is-duplicate]').forEach(function (w) {
              wrappers.push(w);
            });
          }
          return wrappers;
        })
        .catch(function () { return []; }); /* Skip failed pages silently */
    })).then(function (pages) {
      /* Append in page order (Promise.all preserves order) */
      pages.forEach(function (wrappers) {
        wrappers.forEach(function (wrapper) {
          /* Ensure all fetched articles start hidden */
          wrapper.style.display = 'none';
          var row = wrapper.querySelector(ARTICLE_SEL);
          if (row) row.style.display = 'none';
          list.appendChild(wrapper);
        });
      });
      /* Re-apply current filter with full article set now in DOM */
      applyFilterUI(section, currentFilter, false);
    });
  }

  /* ── Init ── */

  function init() {
    var section = document.querySelector(SECTION_SEL);
    if (!section || section.hasAttribute(INIT_FLAG)) return;
    section.setAttribute(INIT_FLAG, '1');

    /* Apply initial filter (e.g. from bookmarked URL) */
    applyFilterUI(section, getParam(location.href, 'filter'), false);

    /* Background-load remaining pages so all articles are filterable */
    fetchAdditionalPages(section);

    /* Filter pill clicks */
    section.addEventListener('click', function (e) {
      var pill = e.target.closest(PILL_SEL);
      if (!pill) return;
      e.preventDefault();
      var newFilter = getParam(pill.href, 'filter');
      /* Preserve all current URL params (view, preview_theme_id…), only change filter */
      var url = buildUrl(location.href, { filter: newFilter, page: '' });
      history.pushState({ path: url }, '', url);
      applyFilterUI(section, newFilter, false);
    });

    /* Browser back/forward */
    window.addEventListener('popstate', function () {
      applyFilterUI(section, getParam(location.href, 'filter'), false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
